export const GET_SPECIALTIES_REQUEST = "GET_SPECIALTIES_REQUEST";
export const GET_SPECIALTIES_RESPONSE = "GET_SPECIALTIES_RESPONSE";

export const ADD_SPECIALTY_REQUEST = "ADD_SPECIALTY_REQUEST";

export const EDIT_SPECIALTY_REQUEST = "EDIT_SPECIALTY_REQUEST";

export const GET_SPECIALTY_DETAILS_REQUEST = "GET_SPECIALTY_DETAILS_REQUEST";
export const GET_SPECIALTY_DETAILS_RESPONSE = "GET_SPECIALTY_DETAILS_RESPONSE";

export const DELETE_SPECIALTY_REQUEST = "DELETE_SPECIALTY_REQUEST";
